module.exports = __webpack_public_path__ + "img/jcb.56cb51f.png";